export default "__VITE_ASSET__B8tg8SwX__"